import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { CellIndex, StreamId } from 'types';
import { State } from 'reducers';
import { getActiveCellIndex, getFilteredStreamIds, getActiveCellStreamId, getFilterText } from 'selectors/monitoringSelectors';
import { assignStream } from 'actions/monitoringActions';
import { waitUntilLoaded } from 'ui/shared/waitUntilLoaded';
import { CameraTree as GenericCameraTree } from 'ui/shared/CameraTree';

const RawCameraTree = ({ hideEmptyGroups, streamIds, selectedStreamId, onClickStream }: MergedProps) =>
    <GenericCameraTree
        id="monitoring-camera-tree"
        streamIds={ streamIds }
        selectedStreamId={ selectedStreamId }
        showStreams={ true }
        showResolutions={ true }
        onClickStream={ onClickStream }
        hideEmptyGroups={ hideEmptyGroups }
    />
;

type StateProps = {
    activeCellIndex: CellIndex;
    streamIds: StreamId[];
    selectedStreamId: StreamId | null;
    filterText: string;
};
type DispProps = {
    onClickStream: (activeCellIndex: CellIndex) => (id: string) => void;
};
type MergedProps = {
    hideEmptyGroups: boolean;
    streamIds: StreamId[];
    selectedStreamId: StreamId | null;
    onClickStream: (streamId: StreamId) => void;
};

const mapStateToProps = (state: State) => ({
    activeCellIndex: getActiveCellIndex(state),
    streamIds: getFilteredStreamIds(state),
    selectedStreamId: getActiveCellStreamId(state),
    filterText: getFilterText(state),
});

const mapDispatchToProps = (dispatch: Function) => ({
    onClickStream: (cellIndex: CellIndex) => (streamId: StreamId) => dispatch(assignStream({ streamId, cellIndex })),
});

const mergeProps = ({ activeCellIndex, filterText, ...stateProps }: StateProps, { onClickStream }: DispProps) => ({
    ...stateProps,
    hideEmptyGroups: !!filterText,
    onClickStream: onClickStream(activeCellIndex),
});

export const CameraTree = compose<MergedProps, {}>(
    connect<StateProps, DispProps, MergedProps, {}>(mapStateToProps, mapDispatchToProps, mergeProps),
    waitUntilLoaded({ size: 'small' }),
)(RawCameraTree);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/sidePanel/CameraTree.tsx